import React, { Component } from 'react';

class IconArrowRight extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="9.775" height="14.454" viewBox="0 0 9.775 14.454"><path className="a" d="M1803.616,4362.342l7.57,6.731-7.57,6.2" transform="translate(-1802.951 -4361.595)" fill="none" stroke="#808495" strokeWidth="2px" /></svg>
        );
    }
}

export default IconArrowRight;